// extracted by mini-css-extract-plugin
export default {"index":"PageJudge_index__uLd8e","score":"PageJudge_score__09jD8","title":"PageJudge_title__EfbUQ","radioStyle":"PageJudge_radioStyle__ZEFp0","spanHtml":"PageJudge_spanHtml__vGFPP"};